const Status = {
    // 未审核
    StatusJobUnaudited: 0,
    // 等待调度
    StatusJobOk: 1,
    // 定时中
    StatusJobTiming: 2,
    // 执行中
    StatusJobRunning: 3,
    // 已停止
    StatusJobStop: 4
}

export default Status



// WEBPACK FOOTER //
// ./src/config/status.ts